import React from 'react';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import { motion, AnimatePresence } from 'motion/react';

const HoverCardTriggerWrap = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(function HoverCardTriggerWrap({ children, className = '', ...props }, ref) {
  return (
    <span ref={ref} className={`inline-flex rounded-full ${className}`.trim()} {...props}>
      {children}
    </span>
  );
});

const HoverCardContentMotion = React.forwardRef<
  HTMLDivElement,
  { children: React.ReactNode }
>(function HoverCardContentMotion({ children }, ref) {
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, scale: 0.92, y: 4 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      exit={{ opacity: 0, scale: 0.92, y: 4 }}
      transition={{ type: 'spring', stiffness: 400, damping: 30 }}
      className="z-50 rounded-xl bg-dark-surface border border-dark-border shadow-lg p-3 min-w-[160px]"
    >
      {children}
    </motion.div>
  );
});

export function MemberHoverCard({ member, children }: any) {
  const [open, setOpen] = React.useState(false);
  const name = member?.displayName || member?.name || member?.username || 'Unknown';
  const username = member?.username;
  const role = member?.role;

  return (
    <HoverCardPrimitive.Root open={open} onOpenChange={setOpen} openDelay={300} closeDelay={100}>
      <HoverCardPrimitive.Trigger asChild>
        <HoverCardTriggerWrap>{children}</HoverCardTriggerWrap>
      </HoverCardPrimitive.Trigger>
      <HoverCardPrimitive.Portal>
        <AnimatePresence initial={false}>
          {open && (
            <HoverCardPrimitive.Content side="top" align="center" sideOffset={8} asChild forceMount>
              <HoverCardContentMotion>
                <p className="text-sm font-semibold text-slate-100">{name}</p>
                {username ? <p className="text-xs text-slate-400">@{username}</p> : null}
                {role ? <p className="text-xs text-slate-400 mt-0.5 capitalize">{role}</p> : null}
                <HoverCardPrimitive.Arrow className="fill-dark-base" />
              </HoverCardContentMotion>
            </HoverCardPrimitive.Content>
          )}
        </AnimatePresence>
      </HoverCardPrimitive.Portal>
    </HoverCardPrimitive.Root>
  );
}

export default MemberHoverCard;
